<div class="form-block_row -quantity-and-direction">
  <div class="form-block_column -quantity-info">
    @if (orderQtyMultiCurrencyInfo?.isMultiCurrencyAllowed) {
      <div class="form-block_column -qty-asset-type"
        >
        <label class="form-block_label" #qtyAssetTypeLabel>{{ORDER_QTY_ASSET_TYPE_LABEL | l10n}}</label>
        <switch class="form-block_switch"
          [formControl]="orderForm.controls.qtyAssetType"
          [config]="orderQtyMultiCurrencyInfo.currencySwitchItems"
          [labelElement]="qtyAssetTypeLabel">
        </switch>
      </div>
    }
    <div class="form-block_column -quantity">
      <label for="quantity_{{id}}" class="form-block_label">
        {{(
        orderQtyMultiCurrencyInfo?.isQtyInputInContracts
        ? 'components.widgets.trade-widget.quantity_in_contracts'
        : 'components.widgets.trade-widget.quantity'
        ) | l10n}}
      </label>
      <decimal-input-wrapper>
        <input class="form-block_value" type="text"
          [min]="$safeNavigationMigration(qtyInputParams?.min)"
          [max]="$safeNavigationMigration(qtyInputParams?.max)"
          [step]="$safeNavigationMigration(qtyInputParams?.step)"
          [decimal]="$safeNavigationMigration(qtyInputParams?.decimalCount)"
          [precision]="$safeNavigationMigration(qtyInputParams?.precision)"
          [formControl]="orderForm.controls.quantity" id="quantity_{{id}}" decimalInput />
      </decimal-input-wrapper>
      @if (orderQtyMultiCurrencyInfo?.isMultiCurrencyAllowed && orderForm.controls.quantity.enabled) {
        <div class="form-block_value-hint">
          <svg class="form-block_value-hint_icon"><use xlink:href="#total"></use></svg>
          <span class="form-block_value-hint_text">
            <span [displayDecimal]="lastOppositeCurrencyQty"
              [formatter]="oppositeCurrencyQtyFormatter"
              [dashIfEmpty]="true">
            </span>
            {{qtyOppositeCurrencySymbol}}
          </span>
        </div>
      }
    </div>
    <ng-container [ngTemplateOutlet]="maxShowTpl"></ng-container>
  </div>
  <div class="form-block_column -side-order-type-info">
    <div class="form-block_column -order-direction">
      <label class="form-block_label" #sideLabel>{{'enums.side.label' | l10n}}</label>
      <switch class="form-block_switch"
        [formControl]="orderForm.controls.side"
        [config]="SIDE_SWITCH_CONFIG"
        [labelElement]="sideLabel">
      </switch>
    </div>
    @if (orderForm.controls.algoType.value !== OrderAlgoType.TWAP) {
      <div class="form-block_column -order-type">
        <label class="form-block_label -bottom-indent" #orderTypeLabel>{{'enums.order-type.label' | l10n}}</label>
        <select-input class="form-block_select-input"
          placeholder="enums.order-type.label"
          [selectMenuItems]="orderTypeMenuItems"
          [formControl]="orderForm.controls.orderType"
          [labelElement]="orderTypeLabel">
        </select-input>
      </div>
    }
  </div>
</div>
<div class="form-block_row -prices-and-instructions">
  <ng-template #limitPriceTpl>
    @if (orderForm.controls.orderType.value === ORDER_TYPE.STOP_LIMIT || orderForm.controls.orderType.value === ORDER_TYPE.LIMIT) {
      <div class="form-block_column -limit-price"
        >
        <label for="limitPrice_{{id}}" class="form-block_label">{{'components.widgets.order-details-widget.limit_price' | l10n}}</label>
        <decimal-input-wrapper>
          <input class="form-block_value" type="text"
            [min]="$safeNavigationMigration(symbolDecimalsInputParams?.min.price)"
            [max]="$safeNavigationMigration(symbolDecimalsInputParams?.max.price)"
            [step]="$safeNavigationMigration(symbolDecimalsInputParams?.steps.price)"
            [decimal]="$safeNavigationMigration(symbolDecimalsInputParams?.decimals.price)"
            [precision]="$safeNavigationMigration(symbolDecimalsInputParams?.precision.price)"
            [formControl]="orderForm.controls.limitPrice" id="limitPrice_{{id}}" decimalInput />
        </decimal-input-wrapper>
      </div>
    }
  </ng-template>

  @if (orderForm.controls.algoType.value !== OrderAlgoType.TWAP) {
    <div class="form-block_column -price-info">
      @if (orderForm.controls.orderType.value === ORDER_TYPE.STOP) {
        <div class="form-block_column -limit-price"></div>
      }
      <ng-container [ngTemplateOutlet]="limitPriceTpl"></ng-container>
      <ng-container [ngTemplateOutlet]="maxUnfilledTpl"></ng-container>
      @if (orderForm.controls.orderType.value === ORDER_TYPE.STOP_LIMIT || orderForm.controls.orderType.value === ORDER_TYPE.STOP) {
        <div class="form-block_column -stop-price"
          >
          <label for="stopPrice_{{id}}" class="form-block_label">{{'components.widgets.order-details-widget.stop_price' | l10n}}</label>
          <decimal-input-wrapper>
            <input class="form-block_value" type="text"
              [min]="$safeNavigationMigration(symbolDecimalsInputParams?.min.price)"
              [max]="$safeNavigationMigration(symbolDecimalsInputParams?.max.price)"
              [step]="$safeNavigationMigration(symbolDecimalsInputParams?.steps.price)"
              [decimal]="$safeNavigationMigration(symbolDecimalsInputParams?.decimals.price)"
              [precision]="$safeNavigationMigration(symbolDecimalsInputParams?.precision.price)"
              [formControl]="orderForm.controls.stopPrice" id="stopPrice_{{id}}" decimalInput />
          </decimal-input-wrapper>
        </div>
      }
    </div>
    <div class="form-block_column -instructions-info">
      <div class="form-block_column -time-in-force">
        <label class="form-block_label" #timeInForceLabel>{{'enums.time-in-force.label' | l10n}}</label>
        <switch class="form-block_switch"
          [formControl]="orderForm.controls.timeInForce"
          [config]="TIME_IN_FORCE_SWITCH_CONFIG"
          [labelElement]="timeInForceLabel">
        </switch>
      </div>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="limitPriceTpl"></ng-container>
    <div class="form-block_column -time-range">
      <label class="form-block_label">{{'components.widgets.order-details-widget.twap_time' | l10n}}</label>
      <date-time-range-picker
        [formControl]="orderForm.controls.twapTimeRange">
      </date-time-range-picker>
    </div>
  }
</div>
@if (orderForm.controls.algoType.value === OrderAlgoType.TWAP) {
  <div class="form-block_row -params-row">
    <div class="form-block_column -duration-info">
      <div class="form-block_column -duration">
        <label for="stepDelay_{{id}}" class="form-block_label -bottom-indent">{{'components.widgets.trade-widget.twap_step_delay' | l10n}}</label>
        @if (orderForm.controls.twapStepDelay.enabled) {
          <decimal-input-wrapper>
            <input class="form-block_value" type="text"
              [min]="orderForm.controls.twapStepDelayUnit.value === 1 ? TWAP_STEP_DELAY_MIN_SEC : 1"
              [max]="TWAP_STEP_DELAY_MAX_SEC / orderForm.controls.twapStepDelayUnit.value"
              [decimal]="0"
              [formControl]="orderForm.controls.twapStepDelay" id="stepDelay_{{id}}" decimalInput />
          </decimal-input-wrapper>
        } @else {
          {{orderForm.controls.twapStepDelay.value}} {{twapStepDelayUnitTextSuffix | l10n}}
        }
      </div>
      @if (orderForm.controls.twapStepDelay.enabled) {
        <div class="form-block_column -duration-unit">
          <label class="form-block_label">&nbsp;</label>
          <select-input class="form-block_select-input"
            [selectMenuItems]="TWAP_STEP_DELAY_UNIT_MENU"
            [formControl]="orderForm.controls.twapStepDelayUnit">
          </select-input>
        </div>
      }
    </div>
    <div class="form-block_column -rand-time">
      <label for="randTime_{{id}}" class="form-block_label">{{'components.widgets.trade-widget.twap_random_time_percent' | l10n}}</label>
      <decimal-input-wrapper>
        <input class="form-block_value" type="text"
          [min]="0"
          [max]="25"
          [decimal]="0"
          [formControl]="orderForm.controls.twapRandomTime" id="randTime_{{id}}" decimalInput />
      </decimal-input-wrapper>
    </div>
    <div class="form-block_column -rand-qty">
      <label for="randQty_{{id}}" class="form-block_label">{{'components.widgets.trade-widget.twap_random_qty_percent' | l10n}}</label>
      <decimal-input-wrapper>
        <input class="form-block_value" type="text"
          [min]="0"
          [max]="25"
          [decimal]="0"
          [formControl]="orderForm.controls.twapRandomQty" id="randQty_{{id}}" decimalInput />
      </decimal-input-wrapper>
    </div>
  </div>
}
@if (orderForm.controls.algoType.value === OrderAlgoType.SNIPER) {
  <div class="form-block_row -params-row">
    <div class="form-block_column -duration-info">
      <div class="form-block_column -duration">
        <label for="duration_{{id}}" class="form-block_label -bottom-indent">{{'components.widgets.trade-widget.sniper_delay' | l10n}}</label>
        @if (orderForm.controls.sniperDelay.enabled) {
          <decimal-input-wrapper>
            <input class="form-block_value" type="text"
              [min]="SNIPER_DELAY_MIN_MS / orderForm.controls.sniperDelayUnit.value"
              [max]="SNIPER_DELAY_MAX_MS / orderForm.controls.sniperDelayUnit.value"
              [decimal]="0"
              [formControl]="orderForm.controls.sniperDelay" id="duration_{{id}}" decimalInput />
          </decimal-input-wrapper>
        } @else {
          {{orderForm.controls.sniperDelay.value}} {{sniperDelayUnitTextSuffix | l10n}}
        }
      </div>
      @if (orderForm.controls.sniperDelayUnit.enabled) {
        <div class="form-block_column -duration-unit">
          <label class="form-block_label">&nbsp;</label>
          <select-input class="form-block_select-input"
            [selectMenuItems]="SNIPER_DELAY_UNIT_MENU"
            [formControl]="orderForm.controls.sniperDelayUnit">
          </select-input>
        </div>
      }
    </div>
  </div>
}
@if (orderForm.controls.icebergQty.value) {
  <div class="form-block_row -iceberg-info-row">
    <div class="form-block_column -iceberg-info-col">
      <div class="form-block_column -iceberg-qty">
        <label for="icebergQty_{{id}}" class="form-block_label">{{'components.widgets.order-details-widget.iceberg_qty' | l10n}}</label>
        <decimal-input-wrapper>
          <input class="form-block_value" type="text"
            [min]="symbolDecimalsInputParams.min.quantity"
            [max]="symbolDecimalsInputParams.max.quantity"
            [step]="symbolDecimalsInputParams.steps.quantity"
            [decimal]="symbolDecimalsInputParams.decimals.quantity"
            [precision]="symbolDecimalsInputParams.precision.quantity"
            [formControl]="orderForm.controls.icebergQty" id="icebergQty_{{id}}" decimalInput />
        </decimal-input-wrapper>
      </div>
    </div>
  </div>
}
@if (!isActionsUnavailable) {
  <div class="form-block_row -buttons">
    @if (!isActionsDisabled) {
      <div class="form-block_column -large">
        <button class="form-block_button-large -cancel"
          (click)="goToConfirmation(OrderTransactionType.CANCEL)"
          [disabled]="!orderForm">
          {{'components.widgets.order-details-widget.cancel_order' | l10n}}
        </button>
      </div>
    }
    @if (!isActionsDisabled && !isReplaceDisabled) {
      <div class="form-block_column -large">
        <button class="form-block_button-large -default"
          (click)="goToConfirmation(OrderTransactionType.REPLACE)"
          [disabled]="!orderForm">
          {{'components.widgets.order-details-widget.replace_order' | l10n}}
        </button>
      </div>
    }
  </div>
}
